/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Minimum_10Inputs */



/**
* | output |
* | --- |
* | "Minimum: 10" |
*
* @param {Options_Backup_Minimum_10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_minimum_10 = /** @type {((inputs?: Options_Backup_Minimum_10Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Minimum_10Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minimum : 10")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestens: 10")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minimo: 10")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимум: 10")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mínimo: 10")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最低要求：10")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小: 10")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम: 10")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mínimo: 10")
	return /** @type {LocalizedString} */ ("Minimum: 10")
});